module.exports = __webpack_public_path__ + "static/performance_measurement-a7b89d6b73dd8672753f9a8cd1c777cc.jpg";